import React from "react";
import {connect} from "react-redux";
import {Map, TileLayer, Polygon, ZoomControl, ImageOverlay} from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {IMapas, IParcela, ISections} from "../../../types";
import { ReactComponent as AddParcela } from '../../icons/add_parcela.svg';
import {LatLngTuple} from "leaflet";
import L from "leaflet";


interface IProps {
    setMapa(mapa: IMapas): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
    mapa: IMapas
    parcelas: IParcela[]
    zoom: number
    center: LatLngTuple
    level: number
    usuario: string
    parcela: string
}

interface Istate {
    hover: string
}

const urls = {
    satelite: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    carreteras: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}'
}

class Principal extends React.Component<IProps, Istate> {

    state:Istate = {
        hover: ''
    }

    handleVista = () => {
        if (this.props.mapa === 'satelite') this.props.setMapa('carreteras')
        if (this.props.mapa === 'carreteras') this.props.setMapa('satelite')
        return
    }

    render() {

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%'
                }}
            >
                <Map
                    center={this.props.center}
                    zoom={this.props.zoom}
                    maxZoom={20}
                    style={{
                        width: '100%',
                        height: '100%',
                        zIndex: 1,
                        cursor: "pointer"
                    }}
                    onmoveend={(e) => {
                        this.props.setZoom(e.target.getZoom())
                        this.props.setCenter([e.target.getCenter().lat,e.target.getCenter().lng])
                    }}
                    zoomControl={false}
                >
                    <ZoomControl
                        position={'topright'}
                    />
                    {this.props.mapa === 'satelite' && <TileLayer url={urls.satelite}/>}
                    {this.props.mapa === 'carreteras' && <TileLayer url={urls.carreteras}/>}

                    {this.props.parcelas.map((parcela) =>
                        parcela.eliminada !== 1 && parcela.id === this.props.parcela &&
                        <Polygon
                            key={parcela.id}
                            // onmouseover={() => this.setState({hover: parcela.id})}
                            // onmouseout={() => this.setState({hover: ''})}
                            positions={parcela.lat_lon}
                            color={"blue"}
                            // weight={this.state.hover === parcela.id? 4 : 2}
                            weight={2}
                        />
                    )}

                </Map>

                <div
                    style={{
                        width: 150,
                        height: 150,
                        marginRight: 20,
                        marginLeft: -174,
                        marginBottom: 20,
                        backgroundColor: "transparent",
                        zIndex: 2,
                        borderRadius: 20,
                        borderStyle: "solid",
                        borderWidth:2,
                        borderColor: this.state.hover === 'sat'? 'rgba(0,0,0,0.8)' : 'rgba(0,0,0,0.2)',
                        alignSelf: "flex-end"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: 150,
                            height:150,
                            borderRadius: 20,
                            backgroundColor: this.state.hover === 'sat'? 'rgba(240,240,240)' :
                                this.props.mapa === 'satelite'? 'rgba(128,128,128)' : "white",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                        onMouseEnter={() => this.setState({hover: 'sat'})}
                        onMouseLeave={() => this.setState({hover: ''})}
                        onClick={() => {this.handleVista()}}
                    >
                        <Map
                            center={this.props.center}
                            zoom={Math.floor(this.props.zoom/2)}
                            zoomControl={false}
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: 20,
                            }}
                        >
                            {this.props.mapa === 'carreteras' && <TileLayer url={urls.satelite}/>}
                            {this.props.mapa === 'satelite' && <TileLayer url={urls.carreteras}/>}
                        </Map>

                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    mapa: state.principal.mapa,
    parcelas: state.principal.parcelas,
    zoom: state.principal.zoom,
    center: state.principal.center,
    level: state.navegacion.level,
    usuario: state.principal.usuario,
    parcela: state.navegacion.parcela
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setMapa: (mapa: IMapas) => dispatch({type: "set-principal-mapa", mapa}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center})
});

export default connect(mapStateToProps, mapDispatchToProps)(Principal);
